/**
 * Created by robert.lavoie on 6/21/17.
 */

import { Injectable } from '@angular/core';

// Models
import { Site, SitePage } from 'careerpages-base/models';

// Services
import { SiteService } from './site.service';


/**
 *
 * @class
 * PageService
 *
 * @description
 * This service is responsible for filtering and returning and any information regarding a SitePage
 *
 */
@Injectable()
export class PageService {

  constructor(private siteService: SiteService) {
  }

  /**
   * Retrieves a page within a site
   *
   * @return { Object: SitePage } the page
   */
  getCurrentPage(pageName: string): (SitePage | null) {

    // get the site, at this point we know we have a site
    const site: Site =  this.siteService.getSite();
    // return a page within the site if we have one
    return site['pages'].find(page => page.name === pageName);
  }


}